export const pageSearch = {
  'planType': {
    title: '计划类型',
    type: 'select',
    dictionary: 'A0002'
  },
  'wantCode': {
    title: '要货单号',
    type: 'input'
  },
  'customerName': {
    title: '客户名称',
    type: 'input'
  },
  'customerType': {
    title: '客户类型',
    type: 'select',
    dictionary: 'A0009'
  },
  'quotasYear': {
    title: '配额年度',
    type: 'year'
  },
  'wantStartDate': {
    title: '要货日期',
    type: 'date'
  }
}

export default {
  'wantCode': {
    title: '要货单号',
    slot: true,
    width: 160
  },
  'planTypeTextView': {
    title: '计划类型',
    width: 150
  },
  'saleCenterTextView': {
    title: '营销单元'
  },
  'customerName': {
    title: '订单客户',
    width: 250
  },
  'billCustomer': {
    title: '开票客户',
    width: 250
  },
  'productDesc': {
    title: '产品',
    width: 300
  },
  'wantQuantity': {
    title: '要货量'
  },
  'baseAuditQuantity': {
    title: '基地审批量',
    width: 160,
    // slot: true,
    // columnParams: { bgEdit: true }
  },
  'warAuditQuantity': {
    title: '战区审批量',
    width: 160,
    // slot: true,
    // columnParams: { bgEdit: true }
  },
  'salecenterAuditQuantity': {
    title: '销售内勤审批量',
    width: 160,
    // slot: true,
    // columnParams: { bgEdit: true }
  },
  // 'handleOpinion': {
  //   title: '审批意见',
  //   slot: true,
  //   columnParams: { bgEdit: true }
  // },
  'isShunt': {
    title: '是否分流'
  },
  'shuntDealer': {
    title: '分流经销商'
  },
  'receiveUnitName': {
    title: '收货单位'
  },
  'spurtCodeUnit': {
    title: '喷码单位'
  },
  'contacPerson': {
    title: '收货联系人'
  },
  'contactNumber': {
    title: '收货联系电话'
  },
  'receiveAddress': {
    title: '收货地址'
  },
  'createdDate': {
    title: '创建日期'
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/business-processing/config/toGoodsBatchApprove.js